export default class PaginationFootballProperties {
    public currentPage: number = null;
    public itemsPerPage: number = null;
    public totalItems: number = null;
    public numberOfPages: number = null;
}